import { css, jsx } from '@emotion/react';
import { baseReset } from '../../../utils/style-mixins/reset';
const DividerStyles = css(Object.assign(Object.assign({}, baseReset), { borderTop: `1px solid var(--zds-stroke-weaker, #D7D3C9)`, margin: 'var(--zds-space-12, 12px) 0' }));
export const Divider = () => jsx("hr", { css: DividerStyles, "data-zds": true });
//# sourceMappingURL=Divider.js.map
// @zapier/universal-layout@12.2.5 (07fb29cf3)
